<template>
  <div class="OAModalDetail">
    <el-dialog
      :visible.sync="visibleCopy"
      width="500px"
      @close="onClose"
      :lock-scroll="true"
      :title="title"
    >
      <form-component :form-data="formData" ref="formData" :label-width="labelWidth||'120px'"></form-component>
    </el-dialog>
  </div>
</template>
<script>
import formComponent from "@/components/formComponents/form-component.vue";
export default {
  name: "OAModalDetail",
  props: ["title", "visible", "formData", "labelWidth"],
  components: { formComponent },
  data() {
    return { visibleCopy: false };
  },
  methods: {
    onClose() {
      this.$emit("on-close");
    }
  },
  watch: {
    visible: {
      handler: function(val, oldVal) {
        this.visibleCopy = val;
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {}
};
</script>
<style lang="scss">
.OAModalDetail {
  .el-dialog__footer {
    text-align: center;
  }
  .el-dialog__body {
    padding: 10px 20px;
    .form_combination .el-form .el-form-item{
        margin-bottom: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/OAModalDetail/OAModalDetail.vue